function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2330",
  "data-name": "Group 2330",
  transform: "translate(1301.527 273.33)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2327",
  "data-name": "Group 2327",
  transform: "translate(-1301.527 -273.33)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13426",
  "data-name": "Path 13426",
  d: "M-1280.742-261.014v-7.206a3.012,3.012,0,0,0-3.012-3.012h-12.663a3.021,3.021,0,0,0-3.012,3.012v12.663a3.021,3.021,0,0,0,3.012,3.012h6.9c1.822,0,1.814,2.1,0,2.1h-6.9a5.11,5.11,0,0,1-5.11-5.11V-268.22a5.11,5.11,0,0,1,5.11-5.11h12.663a5.11,5.11,0,0,1,5.11,5.11v7.206a1.049,1.049,0,0,1-1.049,1.049h0A1.049,1.049,0,0,1-1280.742-261.014Z",
  transform: "translate(1301.527 273.33)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2328",
  "data-name": "Group 2328",
  transform: "translate(-1293.636 -266.842)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13427",
  "data-name": "Path 13427",
  d: "M-1265.568-244.442a1.057,1.057,0,0,1-1.056,1.056,1.057,1.057,0,0,1-1.056-1.056,1.059,1.059,0,0,1,1.056-1.058A1.059,1.059,0,0,1-1265.568-244.442Z",
  transform: "translate(1267.68 245.5)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2329",
  "data-name": "Group 2329",
  transform: "translate(-1296.995 -265.357)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13428",
  "data-name": "Path 13428",
  d: "M-1281.04-231.757a1.044,1.044,0,0,1-.651-.227,1.049,1.049,0,0,1-.17-1.474l1.737-2.192a1.792,1.792,0,0,1,1.317-.677,1.785,1.785,0,0,1,1.377.544l.518.535,3.166-3.326a1.8,1.8,0,0,1,1.534-.542,1.8,1.8,0,0,1,1.34.922l2.477,4.555a1.049,1.049,0,0,1-.421,1.423,1.049,1.049,0,0,1-1.423-.42l-2.277-4.187-3.1,3.253a1.8,1.8,0,0,1-1.292.557,1.771,1.771,0,0,1-1.3-.546l-.5-.513-1.521,1.919A1.047,1.047,0,0,1-1281.04-231.757Z",
  transform: "translate(1282.088 239.129)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2979",
  "data-name": "Rectangle 2979",
  width: 9.325,
  height: 2.098,
  rx: 1.049,
  transform: "translate(-1286.076 -253.943)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2980",
  "data-name": "Rectangle 2980",
  width: 9.325,
  height: 2.098,
  rx: 1.049,
  transform: "translate(-1282.463 -248.232) rotate(-90)"
}));

var SvgCategories = function SvgCategories(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.776,
    height: 25.098,
    viewBox: "0 0 24.776 25.098",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCategories, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/categories.2a638c43.svg";
export { ForwardRef as ReactComponent };